import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  EyeIcon,
  HStack,
  SettingsIcon,
  Stack,
  Text,
  TrashIcon,
} from '@shared/ui';

export function IconsShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.icons.showcase.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.icons.showcase.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Stack gap="md">
          <Text size="sm" color="muted">
            {t('uiLibrary.icons.description')}
          </Text>
          <HStack gap="lg" align="center" className="flex-wrap">
            <HStack gap="sm" align="center">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                <SettingsIcon size={18} />
              </span>
              <Text size="sm">{t('uiLibrary.icons.items.settings')}</Text>
            </HStack>
            <HStack gap="sm" align="center">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary">
                <EyeIcon size={18} />
              </span>
              <Text size="sm">{t('uiLibrary.icons.items.eye')}</Text>
            </HStack>
            <HStack gap="sm" align="center">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10 text-destructive">
                <TrashIcon size={18} />
              </span>
              <Text size="sm">{t('uiLibrary.icons.items.trash')}</Text>
            </HStack>
          </HStack>
        </Stack>
      </CardContent>
    </Card>
  );
}
